import QuoteForm from '../components/QuoteForm';
import TrustBar from '../components/TrustBar';
import SEO from '../components/SEO';
import { ShieldCheck, Clock, ThumbsUp } from 'lucide-react';

export default function QuotePage() {
  return (
    <>
      <SEO title="Get a Free Removals Quote — Laraé Logistics London"
        description="Get an instant fixed-price quote for house removals, man and van or office relocations in London. Reply within 1 working hour." />
      <section className="bg-forest text-white py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
          <p className="font-manrope text-sm text-oat uppercase tracking-widest mb-3">Free Quote</p>
          <h1 className="font-outfit text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight max-w-3xl">Tell us about your move.</h1>
          <p className="font-manrope text-base md:text-lg text-white/80 mt-5 max-w-2xl">Three short steps. Fixed-price quote — we typically reply within 10 minutes during working hours.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-3 mt-7 text-sm text-white/75 font-manrope">
            <span className="flex items-center gap-1.5"><ShieldCheck size={14} /> Fully insured</span>
            <span className="flex items-center gap-1.5"><Clock size={14} /> 60s to complete</span>
            <span className="flex items-center gap-1.5"><ThumbsUp size={14} /> No obligation · no deposit</span>
          </div>
        </div>
      </section>
      <TrustBar />
      <section className="py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-5 md:px-8 lg:px-12">
          <QuoteForm sourcePage="quote-page" />
        </div>
      </section>
    </>
  );
}
